/* istanbul ignore file */
import React from 'react';
import useFeatureToggleService from 'feature-toggle';

import ErrorsWrapper from './ErrorsWrapper';
import { InputLabel, RadioButton, RadioButtonsGroupLayoutProps, SimpleBlock } from 'ui-builder';
import ShadcnRadioButtonsGroupLayout from './ShadcnRadioButtonsGroupLayout';

function LegacyRadioButtonsGroupLayout(props: RadioButtonsGroupLayoutProps<string | number>) {
  return (
    <ErrorsWrapper name={props.name} errors={props.errors}>
      <SimpleBlock>
        <InputLabel
          label={props.label}
          className={props.labelClassName}
          hideLabel={props.hideLabel}
          source={props.name}
          bold
        />
        <div>
          {props.options && props.options.map((option) => {
            return (
              <RadioButton
                key={`radio-button-option-value-${option.value}`}
                value={props.value === option.value}
                groupValue={option.value}
                isDisabled={option.disabled}
                label={option.label}
                source={props.name}
                onChangeCallback={() => {
                  props.onChangeCallback!({
                    target: {
                      value: option.value,
                    },
                  });
                }}
                hint={option.description}
                title={option.title}
              />
            );
          })}
        </div>
        {props.hint && (
          <div className="hint">
            {props.hint}
          </div>
        )}
      </SimpleBlock>
    </ErrorsWrapper>
  );
}

function RadioButtonsGroupLayout(props: RadioButtonsGroupLayoutProps<string | number>) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnRadioButtonsGroupLayout {...props} />;
  } else {
    return <LegacyRadioButtonsGroupLayout {...props} />;
  }
}

export default RadioButtonsGroupLayout;
